/** Convert ISO date string to YYYY-MM-DD for date input */
export const dateToInput = (v: string | null | undefined): string =>
  v ? v.substring(0, 10) : '';

/** Convert YYYY-MM-DD to ISO string for API */
export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;

/** Format number with thousands separator */
export const fmt = (v: number | null | undefined): string =>
  (v == null || v === 0)
    ? '0'
    : v.toLocaleString('en-US', { maximumFractionDigits: 2 });

/** 票款別 options */
export const PAYMENT_TYPE_OPTIONS = [
  { value: '01', label: '現金' },
  { value: '02', label: '押匯' },
  { value: '03', label: '支票' },
  { value: '04', label: '電匯' },
  { value: '05', label: '轉帳' },
  { value: '06', label: '沖暫借款' },
  { value: '07', label: '沖預收款' },
  { value: '11', label: '應付代付款' },
];

/** 票款別 code to display text */
export const paymentTypeLabel = (code: string): string => {
  const opt = PAYMENT_TYPE_OPTIONS.find(o => o.value === code);
  return opt ? opt.label : '';
};

/** 款項別 options for detail grid */
export const ITEM_TYPE_OPTIONS = [
  { value: '01', label: '原料貨款' },
  { value: '02', label: '成本貨款' },
  { value: '03', label: '工繳貨款' },
  { value: '04', label: '費用' },
  { value: '05', label: '暫借款' },
  { value: '06', label: '其他支出' },
  { value: '07', label: '沖預收款' },
  { value: '16', label: '繳款退回' },
];

/** 款項別 code to display text */
export const itemTypeLabel = (code: string): string => {
  const opt = ITEM_TYPE_OPTIONS.find(o => o.value === code);
  return opt ? opt.label : '';
};

/** Status label mapping for FH110_80 */
export const statusLabel = (fh110_80: string, fh110_20?: string, fh110_51?: string): string => {
  if (fh110_20 === 'P') return '已沖帳';
  if (fh110_51 === 'P') return '沖賬中';
  switch (fh110_80) {
    case 'P': return '已核准';
    case 'A': return '會計審核中';
    case 'B': return '已會簽';
    case 'C': return '單位主管審核中';
    case 'D': return '送審中';
    case '1': return 'HQ已審核';
    case '2': return '部長已審核';
    case '3': return '處長已審核';
    case '4': return '課長已審核';
    case '5': return '組長已審核';
    default: return '';
  }
};
